// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"265":"4cd42518","834":"14999c62"}[chunkId] + ".chunk.css";
};